import script from "./FeaturedItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedItem.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedItem.vue?vue&type=style&index=0&id=59b8f69e&lang=scss"

const __exports__ = script;

export default __exports__